import PropTypes from 'prop-types';
import React from 'react';

import get from 'lodash/get';
import { useFormContext } from 'react-hook-form';

import ErrorMessage from 'components/form/ErrorMessage';
import Label from 'components/form/Label';
import InputFieldCurrency from 'components/form/inputFields/InputFieldCurrency/InputFieldCurrency';

const ContentElementFundraiseCapitalRaised = ({ index = 0 }) => {
  const name = 'capitalRaised';
  const {
    watch,
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, `${name}.amount`, null);
  const currency = watch(`${name}.currency`);

  return (
    <div className="w-full">
      <div className="space-y-2">
        <Label htmlFor={`${name}${index}`}>Amount of capital raised*</Label>
        <InputFieldCurrency
          control={control}
          inputRules={{
            valueAsNumber: true,
            required: {
              value: true,
              message: 'Please provide an amount of capital raised',
            },
            min: {
              value: 1,
              message: 'Please provide a valid value',
            },
          }}
          currencyDefaultName={currency}
          nameAmount={`${name}.amount`}
          id={`${name}${index}`}
          testId="company-content-fundraise-inputCapitalRaised"
          nameCurrency={`${name}.currency`}
        />
      </div>
      {error && (
        <ErrorMessage testId="company-content-fundraise-inputCapitalRaised-error">
          {error.message}
        </ErrorMessage>
      )}
    </div>
  );
};

ContentElementFundraiseCapitalRaised.propTypes = {
  index: PropTypes.number,
};

export default ContentElementFundraiseCapitalRaised;
